import { h } from 'preact';
import PaymentWarning from '../PaymentWarning';
import DunningWarning from '../DunningWarning';

const resolvePanelContent = ({
  showPaymentWarning,
  dunningWarning,
  ...props
}) => {
  if (showPaymentWarning) {
    return <PaymentWarning {...props} />;
  }
  if (dunningWarning) {
    return <DunningWarning stage={dunningWarning} />;
  }

  return <span />;
};

export default props => {
  const content = resolvePanelContent(props);
  return (
    content && (
      <div className="as-ActionPanel">
        <div className="content">{content}</div>
      </div>
    )
  );
};
